module.exports = __webpack_public_path__ + "static/media/jewelry-ring-gold.d7b4702f.svg";